import {RadioButton as R} from './RadioButton';
import {Button} from './Button';

export const RadioButton = Object.assign(R, {Button})
